import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateCategoryRequestBody,
  IApiCreateCategoryResponseBody,
} from '../CategoriesApi.types';
import { useApi } from '~/lib/api/useApi';
import { onboardingStatusQueryKeyFactory } from '../../Onboarding/hooks/useOnboardingStatusQuery';
import { categoriesQueryKeyFactory } from './useCategoriesQuery';

export type IUseCreateCategoryMutationValues = {
  appId: string;
  body: IApiCreateCategoryRequestBody;
};

export const useCreateCategoryMutation = (): UseMutationResult<
  IApiCreateCategoryResponseBody,
  unknown,
  IUseCreateCategoryMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateCategoryMutationValues) =>
      api.categories.create(values.appId, values.body),
    onSuccess: async (createdCategory, values) => {
      // // TODO once the API is updated to return the created category object
      // queryClient.setQueryData(
      //   categoryQueryKeyFactory({
      //     appId: createdCategory.appId,
      //     categoryId: createdCategory._id,
      //   }),
      //   createdCategory,
      // );
      // await queryClient.invalidateQueries({
      //   queryKey: categoriesQueryKeyFactory({ appId: values.appId }),
      // });

      // In the meantime:
      await queryClient.invalidateQueries({
        queryKey: categoriesQueryKeyFactory({
          appId: values.appId,
          parentCategoryId: createdCategory.parentId,
        }),
      });

      await queryClient.invalidateQueries({
        queryKey: onboardingStatusQueryKeyFactory({
          body: {
            target: 'application',
            id: values.appId,
          },
        }),
      });
    },
  });
};
